export default __webpack_public_path__ + "static/media/invite-link.748e5a4a.png";